import { HttpErrorResponse } from '@angular/common/http';

import { Message } from './message.service';

interface QueryMessage {
  [key: string]: string;
}

interface MessageResponse {
  errorQueryField?: string;
  errorAnyField?: string;
  query?: QueryMessage;
  response?: HttpErrorResponse;
  internalErrorMessage?: string;
}

export class MessageBuilder {
  private status?: number;
  private data: MessageResponse;

  constructor(response?: HttpErrorResponse) {
    this.data = { response };
  }

  public static newInstance(response?: HttpErrorResponse): MessageBuilder {
    return new MessageBuilder(response);
  }

  public addStatus(status: number): MessageBuilder {
    this.status = status;
    return this;
  }

  public addInternalErrorMessage(internalErrorMessage: string): MessageBuilder {
    this.data.internalErrorMessage = internalErrorMessage;
    return this;
  }

  public addAnyField(field: string): MessageBuilder {
    this.data.errorAnyField = field;
    return this;
  }

  public addQueryField(field: string): MessageBuilder {
    this.data.errorQueryField = field;
    return this;
  }

  public addQueryMessage(queryMessage: string, showMessage?: string): MessageBuilder {
    const { query } = this.data;
    this.data.query = { ...query, [queryMessage]: showMessage || queryMessage };
    return this;
  }

  public build(): Message {
    const {
      response,
      errorAnyField,
      errorQueryField,
      internalErrorMessage = 'Ops! Ocorreu um erro inesperado, tente novamente.',
    } = this.data;

    if (errorAnyField) {
      return this.buildAnyError(this.data);
    }

    if (errorQueryField) {
      return this.buildQueryError(this.data);
    }

    return { status: this.status || response?.status, message: internalErrorMessage };
  }

  private buildAnyError(data: MessageResponse): Message {
    const { response, errorAnyField, internalErrorMessage = 'Ops! Ocorreu um erro inesperado, tente novamente.' } = data;

    const error = response?.error || {};
    
    let message = internalErrorMessage;

    if (errorAnyField) {
      message = error[errorAnyField];
    }

    return { status: this.status || response?.status, message };
  }

  private buildQueryError(data: MessageResponse): Message {
    const { response, errorQueryField, internalErrorMessage = 'Ops! Ocorreu um erro inesperado, tente novamente.' } = data;

    const error = response?.error || {};
    const query = this.data?.query || {};

    let message = internalErrorMessage;

    if (errorQueryField) {
      const field = error[errorQueryField];
      message = query[field] || internalErrorMessage;
    }

    return { status: this.status || response?.status, message };
  }
}
